export default __webpack_public_path__ + "65edf31a673fe32672df82501551d99a.png";